exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.password-strength-container{width:260px;min-height:160px;margin-bottom:16px;display:flex;flex-direction:column;align-items:center}.password-strength-container--popup{position:absolute;left:24px;top:211px}.password-strength-container .error-message{font-size:12px;height:15px;width:219px;overflow:hidden;font-family:Open Sans,sans-serif;font-weight:600;line-height:15px;font-style:italic;color:#cd030a}.password-strength-container .visual-indicator-container{display:flex;height:18px;align-items:center;margin-top:8px}.password-strength-container .visual-indicator-container .bar{width:65px;height:4px;margin-left:.5px;margin-right:.5px}.password-strength-container .visual-indicator-container .red{background-color:#cd030a}.password-strength-container .visual-indicator-container .grey{background-color:#ddd}.password-strength-container .visual-indicator-container .green{background-color:#4bb543}.password-strength-container .visual-indicator-container .indicator-text{margin-left:5px;height:18px;font-family:Open Sans,sans-serif;font-size:13px;font-weight:300}.password-strength-container .password-suggestions-container{margin-top:0}.password-strength-container .password-suggestions-container .password-suggestion{width:252px;font-family:Open Sans,sans-serif;font-size:13px;font-weight:300;color:#8b8b8b;margin-bottom:2px}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/PasswordSecurity/PasswordSecurity.scss
// module id = 1592
// module chunks = 0